import React, { useEffect, useState } from 'react';

const Terms = () => {
  const [footer, setFooter] = useState('');

  useEffect(() => {
    fetch('/footer.html')
      .then(response => response.text())
      .then(data => setFooter(data))
      .catch(error => console.error('Error loading footer:', error));
  }, []);

  return (
    <div style={styles.content}>
      <main style={styles.main}>
        <h1>Terms and Conditions</h1>
        <pre style={styles.pre}>
{`Effective Date: January 1, 2026

Welcome to Skroop.org ("we," "us," "our"). These Terms and Conditions ("Terms") govern your access to and use of our website, mobile applications, and any related services, content, subscriptions, and communications (collectively, the "Services"). By accessing or using the Services, you agree to be bound by these Terms. If you do not agree, do not use the Services.

1. Use of Our Services

Our Services are provided for informational, educational, and community-building purposes related to the mission of The Scrupulous Principle Ltd.

The Services are intended for a general audience. Certain features, including account creation, subscriptions, and personalized services, are intended for use by adults. If you are under 18, you may use the Services only with the involvement and consent of a parent or legal guardian.

You agree to use the Services only for lawful purposes and in accordance with these Terms.

2. Accounts and Access

Some features of the Services may require you to create an account. You are responsible for maintaining the confidentiality of your account credentials and for all activity that occurs under your account.

We reserve the right to suspend or terminate accounts that violate these Terms or applicable laws.

3. Intellectual Property

All content made available through the Services--including text, images, audio, video, logos, trademarks, and designs--is owned by or licensed to The Scrupulous Principle Ltd. and is protected by applicable intellectual property laws.

You may not copy, modify, distribute, sell, or exploit any content without our prior written consent.

If you believe your intellectual property rights have been infringed, please contact us at virtue@skroop.org.

4. Subscriptions, Payments, and Billing

Certain Services may be offered on a subscription or paid basis.

a. Payment Processing

Payments may be processed through third-party payment processors or platform providers (for example, through a mobile application marketplace or web-based payment provider). We do not store full payment card details.

b. Auto-Renewing Subscriptions

If you purchase a subscription, it may automatically renew unless canceled prior to the end of the current billing period. Renewal charges will be applied using the payment method associated with your account.

c. Managing and Canceling Subscriptions

Subscription management, including cancellation, renewal status, and billing history, must be handled through the platform or payment provider through which the subscription was purchased.

d. Pricing Changes

We reserve the right to modify subscription pricing or offerings at any time, subject to applicable law and platform rules. Changes will not affect an active billing period.

e. Refunds

Refunds, if any, are governed by the policies of the platform or payment processor used to complete the transaction. We do not directly issue refunds for purchases processed by third-party platforms unless required by law.

5. Donations and Contributions

We may accept voluntary donations to support our mission. Donations are non-refundable unless required by law.

We do not provide tax, legal, or financial advice regarding donations.

6. User-Generated Content

If you submit content to the Services, you grant us a non-exclusive, royalty-free, perpetual, and irrevocable license to use, reproduce, modify, and distribute that content in connection with the Services.

You represent that you have the rights necessary to submit such content and that it does not violate any laws or third-party rights.

We reserve the right to remove content at our discretion.

7. Third-Party Services and Links

The Services may include links to or integrations with third-party websites or services. We do not control and are not responsible for their content, policies, or practices.

Your use of third-party services is at your own risk and subject to their terms.

8. Disclaimer of Warranties

The Services are provided "as is" and "as available." We make no warranties of any kind, express or implied, including warranties of accuracy, reliability, or fitness for a particular purpose.

We do not guarantee uninterrupted or error-free operation of the Services.

9. Limitation of Liability

To the maximum extent permitted by law, The Scrupulous Principle Ltd. shall not be liable for any indirect, incidental, consequential, or punitive damages arising from your use of the Services.

Your sole remedy for dissatisfaction with the Services is to stop using them.

10. Indemnification

You agree to indemnify and hold harmless The Scrupulous Principle Ltd., its officers, directors, employees, and affiliates from any claims arising out of your use of the Services or violation of these Terms.

11. Governing Law and Jurisdiction

These Terms are governed by the laws of the State of New York, without regard to conflict-of-law principles. Any disputes shall be resolved in New York, NY, unless otherwise required by law.

12. Changes to These Terms

We may update these Terms from time to time. The updated version will be posted with a revised Effective Date. Continued use of the Services constitutes acceptance of the revised Terms.

13. Contact Information

The Scrupulous Principle Ltd.
1178 Broadway, 3rd Floor Box #543
New York, NY 10001
virtue@skroop.org`}
        </pre>
      </main>
      <div dangerouslySetInnerHTML={{ __html: footer }} />
    </div>
  );
};

const styles = {
  content: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    padding: 20,
    maxWidth: 800,
    margin: '0 auto'
  },
  main: {
    flex: 1,
    paddingBottom: 80
  },
  pre: {
    whiteSpace: 'pre-wrap',
    fontFamily: 'Arial, sans-serif',
    lineHeight: 1.6
  }
};

export default Terms;
